"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var fos_ui_1 = require("@ntet/fos-ui");
var SessionTimeoutModal = function (props) {
    var open = props.open, onClose = props.onClose, onConfirm = props.onConfirm, onSecondary = props.onSecondary, timeRemainingInMilliseconds = props.timeRemainingInMilliseconds;
    if (!open) {
        return null;
    }
    var timeRemaining = new Date(timeRemainingInMilliseconds)
        .toISOString()
        .slice(14, -5);
    return (react_1.default.createElement(fos_ui_1.Modal, { title: "Your session is about to expire.", closeBtnText: "LOGOUT", confirmBtnText: "CONTINUE", open: open, onClose: onClose, onConfirm: onConfirm, onSecondary: onSecondary },
        react_1.default.createElement(Label, null, "You will be logged out in"),
        react_1.default.createElement(Timer, null, timeRemaining)));
};
SessionTimeoutModal.propTypes = {
    open: prop_types_1.default.bool.isRequired,
    onClose: prop_types_1.default.func.isRequired,
    onConfirm: prop_types_1.default.func.isRequired,
    onSecondary: prop_types_1.default.func.isRequired,
    timeRemainingInMilliseconds: prop_types_1.default.number.isRequired,
};
var Label = styled_components_1.default.p(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  font-size: 1.5rem;\n  margin: 0;\n  margin-bottom: 0.4rem;\n  width: 45rem;\n"], ["\n  font-size: 1.5rem;\n  margin: 0;\n  margin-bottom: 0.4rem;\n  width: 45rem;\n"])));
var Timer = styled_components_1.default.p(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  font-family: ", ";\n  margin: 0;\n  font-size: 3rem;\n"], ["\n  font-family: ", ";\n  margin: 0;\n  font-size: 3rem;\n"])), function (props) { return props.theme.fonts.robotoLight; });
exports.default = SessionTimeoutModal;
var templateObject_1, templateObject_2;
